import request from './index'

// 获取自动推送首页数据（任务列表+统计+条件+内容）
export function getIndex(params) {
  return request({
    url: '/auto-push',
    method: 'get',
    params
  })
}

// 新增推送任务
export function saveTask(data) {
  return request({
    url: '/auto-push/task/save',
    method: 'post',
    data
  })
}

// 获取推送任务详情（含下拉选项数据）
export function getTask(id) {
  return request({
    url: '/auto-push/task/' + id,
    method: 'get'
  })
}

// 更新推送任务
export function updateTask(id, data) {
  return request({
    url: '/auto-push/task/update/' + id,
    method: 'post',
    data
  })
}

// 删除推送任务
export function deleteTask(id) {
  return request({
    url: '/auto-push/task/delete/' + id,
    method: 'post'
  })
}

// 切换推送任务启用/禁用
export function toggleTask(id) {
  return request({
    url: '/auto-push/task/' + id + '/toggle',
    method: 'post'
  })
}

// 提醒类型清单（只返回已实现的类型，含只读中英文案样例与落地页）
export function getReminderTypes() {
  return request({
    url: '/auto-push/reminder-types',
    method: 'get'
  })
}

// 获取条件列表
export function getConditions() {
  return request({
    url: '/auto-push/conditions',
    method: 'get'
  })
}

// 新增条件
export function saveCondition(data) {
  return request({
    url: '/auto-push/condition/save',
    method: 'post',
    data
  })
}

// 获取条件详情（含关联内容）
export function getCondition(id) {
  return request({
    url: '/auto-push/condition/' + id,
    method: 'get'
  })
}

// 更新条件
export function updateCondition(id, data) {
  return request({
    url: '/auto-push/condition/update/' + id,
    method: 'post',
    data
  })
}

// 删除条件
export function deleteCondition(id) {
  return request({
    url: '/auto-push/condition/delete/' + id,
    method: 'post'
  })
}

// 立即执行推送
export function executeNow(data) {
  return request({
    url: '/auto-push/execute',
    method: 'post',
    data
  })
}

// 任务干跑预览
export function previewTask(id) {
  return request({
    url: '/auto-push/task/' + id + '/preview',
    method: 'get'
  })
}

// 获取推送日志
export function getLogs(params) {
  return request({
    url: '/auto-push/logs',
    method: 'get',
    params
  })
}
